// Enums
export var DatatrackDataTypes;
(function (DatatrackDataTypes) {
    DatatrackDataTypes[DatatrackDataTypes["BeaconControl"] = 0] = "BeaconControl";
    DatatrackDataTypes[DatatrackDataTypes["BeaconEvent"] = 1] = "BeaconEvent";
    DatatrackDataTypes[DatatrackDataTypes["PlayerControl"] = 2] = "PlayerControl";
    DatatrackDataTypes[DatatrackDataTypes["PlayerEvent"] = 3] = "PlayerEvent";
    DatatrackDataTypes[DatatrackDataTypes["Chat"] = 4] = "Chat";
})(DatatrackDataTypes || (DatatrackDataTypes = {}));
export var BeaconActions;
(function (BeaconActions) {
    BeaconActions[BeaconActions["startPresentation"] = 0] = "startPresentation";
    BeaconActions[BeaconActions["startScreenShare"] = 1] = "startScreenShare";
    BeaconActions[BeaconActions["stopPresentation"] = 2] = "stopPresentation";
})(BeaconActions || (BeaconActions = {}));
export var BeaconEvents;
(function (BeaconEvents) {
    BeaconEvents[BeaconEvents["presentationHeartbeat"] = 0] = "presentationHeartbeat";
    BeaconEvents[BeaconEvents["attendeeReady"] = 1] = "attendeeReady";
    BeaconEvents[BeaconEvents["attendeeIframeReady"] = 2] = "attendeeIframeReady";
    BeaconEvents[BeaconEvents["recordingStatus"] = 3] = "recordingStatus";
    BeaconEvents[BeaconEvents["shareScreen"] = 4] = "shareScreen";
    BeaconEvents[BeaconEvents["stopAllShareScreen"] = 5] = "stopAllShareScreen";
})(BeaconEvents || (BeaconEvents = {}));
// We assign hard coded numbers here to maintain backwards
// compatability with existing data which used these numbers
export var PlayerActions;
(function (PlayerActions) {
    PlayerActions[PlayerActions["next"] = 0] = "next";
    PlayerActions[PlayerActions["prev"] = 1] = "prev";
    PlayerActions[PlayerActions["gotoSlide"] = 2] = "gotoSlide";
    PlayerActions[PlayerActions["jumpToAnim"] = 10] = "jumpToAnim";
    PlayerActions[PlayerActions["animateTransform"] = 30] = "animateTransform";
    PlayerActions[PlayerActions["authCloudFront"] = 27] = "authCloudFront";
})(PlayerActions || (PlayerActions = {}));
export var PlayerEvents;
(function (PlayerEvents) {
    PlayerEvents[PlayerEvents["onLoadingStart"] = 0] = "onLoadingStart";
    PlayerEvents[PlayerEvents["onLoadingEnd"] = 1] = "onLoadingEnd";
    PlayerEvents[PlayerEvents["onSlideChange"] = 2] = "onSlideChange";
    PlayerEvents[PlayerEvents["onMovToNxtAnim"] = 3] = "onMovToNxtAnim";
    PlayerEvents[PlayerEvents["onMovToPrvAnim"] = 4] = "onMovToPrvAnim";
    PlayerEvents[PlayerEvents["onPlayingStart"] = 5] = "onPlayingStart";
    PlayerEvents[PlayerEvents["onPlayingEnd"] = 6] = "onPlayingEnd";
    PlayerEvents[PlayerEvents["onProgressChange"] = 7] = "onProgressChange";
    PlayerEvents[PlayerEvents["onSlideEnd"] = 8] = "onSlideEnd";
    PlayerEvents[PlayerEvents["onSldOutlineLoad"] = 9] = "onSldOutlineLoad";
    PlayerEvents[PlayerEvents["initaliseSettings"] = 10] = "initaliseSettings";
    PlayerEvents[PlayerEvents["mouseEvent"] = 11] = "mouseEvent";
    PlayerEvents[PlayerEvents["statusEvent"] = 12] = "statusEvent";
    PlayerEvents[PlayerEvents["swipeVertical"] = 13] = "swipeVertical";
})(PlayerEvents || (PlayerEvents = {}));
// Classes
export class DatatrackData {
    constructor() {
        this.timestamp = new Date();
    }
}
export class ControlData extends DatatrackData {
    constructor(action, param) {
        super();
        this.action = action;
        this.param = param;
    }
}
class EventData extends DatatrackData {
    constructor(event, param) {
        super();
        this.event = event;
        this.param = param;
    }
}
class ChatData extends DatatrackData {
    constructor(msg, user, sid, isHost) {
        super();
        this.msg = msg;
        this.timestamp = new Date();
        this.user = user;
        this.isHost = isHost;
        this.sid = sid;
    }
}
export class BeaconControlData extends ControlData {
    constructor(action, param) {
        super(action, param);
        this.type = DatatrackDataTypes.BeaconControl;
    }
}
export class BeaconEventData extends EventData {
    constructor(event, param) {
        super(event, param);
        this.type = DatatrackDataTypes.BeaconEvent;
    }
}
export class PlayerControlData extends ControlData {
    constructor(action, param) {
        super(action, param);
        this.type = DatatrackDataTypes.PlayerControl;
    }
}
export class PlayerEventData extends EventData {
    constructor(event, param) {
        super(event, param);
        this.type = DatatrackDataTypes.PlayerEvent;
    }
}
export class BeaconChatData extends ChatData {
    constructor() {
        super(...arguments);
        this.type = DatatrackDataTypes.Chat;
    }
}
//# sourceMappingURL=index.js.map